import { FC, PropsWithChildren, useEffect } from 'react'
import { useParams } from 'react-router'

import { useBreadcrumbStore } from '@/stores/useBreadcrumbStore'

type Props = {
  param: string
  label?: string
  isLoading?: boolean
  minWidth?: number
  maxWidth?: number
}

export const BreadcrumbSetter: FC<PropsWithChildren<Props>> = ({
  param,
  label,
  isLoading = false,
  minWidth = 60,
  maxWidth = 120,
  children
}) => {
  const { setDynamicLabel, setLoadingState } = useBreadcrumbStore()
  const params = useParams()

  useEffect(() => {
    const paramName = param.startsWith(':') ? param.substring(1) : param

    if (!(paramName in params)) return
    const paramValue = params[paramName as keyof typeof params]

    if (!paramValue) return
    setLoadingState(paramValue, isLoading, minWidth, maxWidth)

    if (!label || isLoading) return
    setDynamicLabel(paramValue, label)
  }, [param, label, isLoading, minWidth, maxWidth, setDynamicLabel, setLoadingState, params])

  return <>{children}</>
}
